/**
 * @fileoverview Skeleton loading state for project card
 */

import { memo } from 'react'
import type { FC } from 'react'
import { Card, Skeleton, Stack, Group, Box } from 'components'

const CARD_MIN_HEIGHT = 400

/**
 * Displays loading skeleton matching project card layout.
 * Used while fetching project data.
 */
export const ProjectCardSkeleton: FC = memo(() => {
  return (
    <Card
      shadow="sm"
      p={0}
      radius="md"
      withBorder={false}
      sx={{ minHeight: CARD_MIN_HEIGHT, display: 'flex', flexDirection: 'column' }}
    >
      <Skeleton height={130} radius={0} sx={{ flexShrink: 0 }} />

      <Stack spacing={8} p="md" sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Skeleton height={48} width="80%" radius="sm" />

        <Box>
          <Skeleton height={12} width="30%" radius="sm" mb={4} />
          <Skeleton height={18} width="50%" radius="sm" />
        </Box>

        <Box sx={{ flex: 1 }}>
          <Skeleton height={12} width="25%" radius="sm" mb={4} />
          <Skeleton height={60} radius="sm" />
        </Box>

        <Group position="apart" mt="auto">
          <Skeleton height={32} width={100} radius="xl" />
          <Skeleton height={32} width={130} radius="xl" />
        </Group>
      </Stack>
    </Card>
  )
})

ProjectCardSkeleton.displayName = 'ProjectCardSkeleton'
